export default __webpack_public_path__ + "b1a1551afc116210f87e7c2321717a6a.jpg";